import { Observable } from 'rxjs';
import { SubscriptionRepository } from '../domain/suscriptions/repository';
import { Subscription, Plan } from '../domain/suscriptions/model';
import HttpClient from '../utils/http-client';

export class SuscriptionRepositoryImplementation extends SubscriptionRepository {
  private httpClient = new HttpClient("", "");

  // --- 1. Catálogo de Planes ---
  getPlans(): Observable<any> {
    return this.httpClient.get_no_refresh('/plans');
  }

  getPlan(id: number): Observable<Plan> {
    return this.httpClient.get(`/plans/${id}`);
  }

  // --- 2. Suscripción Activa ---
  getSubscription(): Observable<Subscription> {
    return this.httpClient.get('/suscriptions/subscription');
  }

  // --- 3. Activación y Tarjeta (La única pegada) ---
  associateSubscription(data: { card_token_id: string; plan_id?: number } | any): Observable<any> {
    return this.httpClient.post('/suscriptions/associate', data);
  }

  // --- 4. Upgrade de Plan ---
  upgradeSubscription(planId: number): Observable<any> {
    return this.httpClient.post('/suscriptions/upgrade', { plan_id: planId });
  }

  // --- 5. Cancelación ---
  cancelSubscription(id: number): Observable<void> {
    return this.httpClient.delete(`/suscriptions/${id}`);
  }

  // --- Métodos de compatibilidad de repositorio ---
  createSubscription(subscriptionData: Partial<Subscription>): Observable<Subscription> {
    return this.httpClient.post('/suscriptions', subscriptionData);
  }

  getSubscriptions(page: number, limit: number): Observable<Subscription[]> {
    return this.httpClient.get(`/suscriptions?page=${page}&limit=${limit}`);
  }

  updateSubscription(id: number, subscriptionData: Partial<Subscription>): Observable<Subscription> {
    return this.httpClient.put(`/suscriptions/${id}`, subscriptionData);
  }
}
